export default {"src":"/_next/static/media/profile.e1664e4c.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};